/**
 * Decides whether the Identity Provider button can be offered.
 *
 * Both the flag and the destination are required: the API sends a redirect URL
 * for every realm, including those without an identity provider, so relying on
 * the URL alone offers a button that leads nowhere.
 *
 * @param hasCustomerIdentityProvider whether the realm authenticates through an IdP
 * @param redirectUrl where the button sends the user
 */
export const isIdpLoginReady = (
  hasCustomerIdentityProvider?: boolean,
  redirectUrl?: string
): boolean => {
  if (String(hasCustomerIdentityProvider) === 'false') return false;

  return Boolean(hasCustomerIdentityProvider && redirectUrl);
};
